export default __webpack_public_path__ + "static/media/update_instantly.222597f2.svg";